import * as React from 'react';
export class Overlays extends React.Component {
    render() {
        return (React.createElement("div", null, this.props.children));
    }
}